import { Col, Collapse, Row, Table } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
interface Props {
  amountDonation: any;
}
export const DonationAmountList = ({ amountDonation }: Props) => {
  const { t } = useTranslation();
  const columns = [
    {
      title: "المستفيد",
      dataIndex: "beneficiary_name",
      key: "beneficiary_name",
      width: "60%",
      render: (beneficiary_name: string) => (
        <span className="takaful--service-request-span">
          {beneficiary_name}
        </span>
      ),
    },
    {
      title: "المبلغ",
      dataIndex: "amount",
      key: "amount",
      render: (amount: any) => (
        <span className="takaful--service-request-span">{amount}</span>
      ),
    },
  ];
  return (
    <div
      className="takaful--collapse-profile-container"
      style={{ marginTop: "2rem" }}
    >
      <div
        className={`takaful--collapse-profile takaful--collapse-label-container takaful--collapse-beneficiary-services  `}
      >
        <Collapse.Panel
          showArrow={false}
          key="0"
          className=" takaful--collapse-label-panel"
          header={
            <div className="takaful--header-profile-container">
              <Row
                className="takaful--content-profile-box1"
                style={{ marginBottom: "0" }}
              >
                <Col
                  xxl={8}
                  xl={8}
                  lg={8}
                  md={8}
                  sm={12}
                  xs={24}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">المبلغ</p>
                </Col>
                <Col
                  xxl={8}
                  xl={8}
                  lg={8}
                  md={8}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    هذا التبرع موجه
                  </p>
                </Col>
                <Col
                  xxl={8}
                  xl={8}
                  lg={8}
                  md={8}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    تاريخ التبرع
                  </p>
                </Col>
              </Row>
            </div>
          }
        ></Collapse.Panel>
      </div>
      <Collapse
        className={`takaful--collapse-profile takaful--collapse-beneficiary-services takaful--collapse-sponsor-requests`}
        accordion
        defaultActiveKey={amountDonation[0].targeted !== "family" ? ["0"] : []}
      >
        {amountDonation?.map((element: any, index: number) => (
          <Collapse.Panel
            className="takaful--header-profile-Panel takaful--collapse-label-panel"
            key={index}
            showArrow={false}
            collapsible={
              element?.targeted === "family" ? "disabled" : undefined
            }
            header={
              <div className="takaful--header-profile-container">
                <Row
                  justify={"space-between"}
                  className="takaful--content-profile-box1 takaful--cancelSponsorShip-list"
                  style={{ marginBottom: "0" }}
                >
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      المبلغ
                    </p>
                  </Col>
                  <Col
                    xxl={8}
                    xl={8}
                    lg={8}
                    md={8}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span takaful--spaced-col">
                      {element?.amount}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      هذا التبرع موجه
                    </p>
                  </Col>
                  <Col
                    xxl={8}
                    xl={8}
                    lg={8}
                    md={8}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.targeted !== false &&
                        t(`targeted.${element?.targeted}`)}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                    تاريخ التبرع
                    </p>
                  </Col>
                  <Col
                    xxl={8}
                    xl={8}
                    lg={8}
                    md={8}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.date
                        ? dayjs(element?.date, "YYYY-MM-DD").format(
                            "YYYY/MM/DD"
                          )
                        : ""}
                    </span>
                  </Col>
                </Row>
              </div>
            }
          >
            <div className="takaful--table-service-container">
              <Table
                className="takaful--table"
                style={{ direction: "rtl" }}
                columns={columns}
                scroll={{ x: "max-content" }}
                dataSource={element?.members}
                pagination={false}
                locale={{
                  emptyText: (
                    <span className="takaful--empty-text-table">
                      لا توجد بيانات
                    </span>
                  ),
                }}
              />
            </div>
          </Collapse.Panel>
        ))}
      </Collapse>
    </div>
  );
};
